import React, { useEffect, useState } from 'react';
import styles from './ServiceIconsList.module.scss';
import { useDispatch, useSelector } from 'react-redux';
import { getService } from '../../../../store/selectors';
import { salonManagementActions } from '../../../../store';
import { useNavigate, useParams } from 'react-router-dom';
import { getActiveSalonId } from '../../../../../Auth/store/selectors';
import TitleSectionBack from '../../../../../Common/TitleSectionBack';
import AvatarIcon from '../../../../../Common/AvatarIcon';
import { getIconUrl, imageEntities } from '../../../../../../utils/ImagesCreator';
import useWindowSize from '../../../../../../utils/useWindowSize';
import clx from 'classnames';
import { useTranslation } from 'react-i18next';
import { Check } from 'lucide-react';

const servicesIcons = [2, 3, 4, 5, 6, 7];

const ServiceIconsList = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { serviceId } = useParams();
  const { isMobile } = useWindowSize();
  const navigate = useNavigate();
  const activeSalonId = useSelector(getActiveSalonId());
  const service = useSelector(getService());
  const [iconId, setIconId] = useState(service.iconaServizio);

  const formedServiceIcons = servicesIcons.map((id) => ({
    value: id,
    icon: getIconUrl(id, imageEntities.icons),
    label: t('services.serviceIconsList.iconLabel', { number: id }),
  }));

  useEffect(() => {
    service.iconaServizio && setIconId(service.iconaServizio);
  }, [service.iconaServizio]);

  useEffect(() => {
    dispatch(salonManagementActions.GET_SERVICE.REQUEST(serviceId, null, { skipLoader: true }));
    return () => {
      dispatch(salonManagementActions.GET_SERVICE.CLEAR());
    };
  }, [serviceId]);

  useEffect(() => {
    if (service?.salone && service?.salone !== activeSalonId) {
      dispatch(salonManagementActions.GET_SERVICE.CLEAR());
      navigate(-1);
    }
  }, [service, activeSalonId]);

  const saveValue = () => {
    if (iconId && iconId !== service.iconaServizio) {
      dispatch(
        salonManagementActions.EDIT_SERVICE.REQUEST({
          idServizio: service.idservezio,
          iconaServizio: iconId,
        }),
      );
    }
  };

  const canSave = Boolean(iconId && iconId !== service.iconaServizio);

  return (
    <div
      className={clx(styles.service_icons_container, {
        [styles.service_icons_container_mobile]: isMobile,
      })}
    >
      <TitleSectionBack
        title={t('services.serviceIconsList.title')}
        description={t('services.serviceIconsList.description')}
      />

      <div className={styles.service_banner}>
        <AvatarIcon name={service.nome || 'S'} icon={service.icon} size={'52px'} />
        <div className={styles.service_banner_text}>
          <span className={styles.service_banner_eyebrow}>
            {t('services.serviceIconsList.associatingService')}
          </span>
          <span className={styles.service_banner_name}>
            {service.nome || t('services.serviceIconsList.serviceFallback')}
          </span>
        </div>
      </div>

      <div className={styles.list_container}>
        <div className={styles.selector_header}>
          <h2 className={styles.selector_title}>{t('services.serviceIconsList.icons')}</h2>
          <p className={styles.selector_hint}>{t('services.serviceIconsList.iconsHint')}</p>
        </div>

        <div className={styles.icons_grid} role="radiogroup" aria-label={t('services.serviceIconsList.icons')}>
          {formedServiceIcons.map((option) => {
            const selected = iconId === option.value;
            return (
              <button
                key={option.value}
                type="button"
                role="radio"
                aria-checked={selected}
                aria-label={option.label}
                className={clx(styles.icon_card, {
                  [styles.icon_card_selected]: selected,
                })}
                onClick={() => setIconId(option.value)}
              >
                <span className={styles.icon_card_preview}>
                  <AvatarIcon icon={option.icon} name={option.label} size={'56px'} />
                </span>
                <span className={styles.icon_card_label}>{option.label}</span>
                {selected ? (
                  <span className={styles.icon_card_check} aria-hidden>
                    <Check size={14} strokeWidth={2.6} />
                  </span>
                ) : null}
              </button>
            );
          })}
        </div>

        <div className={styles.actions_container}>
          <button
            type="button"
            className={styles.confirm_button}
            onClick={saveValue}
            disabled={!canSave}
          >
            {t('services.serviceIconsList.save')}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ServiceIconsList;
